import React, { useState } from "react";
import { fetchAirportByExactCode } from "../../../../Redux/Apis/Flight-Apis";

/**
 * Module-level cache (survives across every <AirportCode> instance/re-render, cleared only on a
 * full page reload) so hovering the same airport code twice — extremely common here, e.g. every
 * "DEL → BDQ" row shares "DEL" — only ever fires one network request per code for the whole
 * popup's lifetime.
 */
const airportInfoCache = new Map();

/**
 * A small IATA code (e.g. "DEL") that shows its full airport name/city/country on hover,
 * fetched on demand from the same masters/flights/airports?code_exact= endpoint the Homepage's
 * From/To popup already uses (see Redux/Apis/Flight-Apis.js's fetchAirportByExactCode). Used
 * everywhere a raw airport code appears in the explainer so an admin doesn't have to know IATA
 * codes by heart.
 */
function AirportCode({ code }) {
  const [info, setInfo] = useState(() => airportInfoCache.get(code) ?? null);
  const [status, setStatus] = useState(() =>
    airportInfoCache.has(code) ? "done" : "idle"
  );

  const handleMouseEnter = () => {
    if (!code || code === "?" || status !== "idle") return;
    setStatus("loading");
    fetchAirportByExactCode(code)
      .then((result) => {
        airportInfoCache.set(code, result);
        setInfo(result);
        setStatus("done");
      })
      .catch(() => setStatus("done"));
  };

  return (
    <span
      className="search-explainer-airport-code"
      onMouseEnter={handleMouseEnter}
    >
      {code}
      <span className="search-explainer-airport-panel">
        {status === "loading" && "Loading…"}
        {status === "done" && info && (
          <>
            <div className="search-explainer-airport-panel-name">
              {info.airport_name}
            </div>
            <div className="search-explainer-airport-panel-sub">
              {[info.city_name, info.country_name].filter(Boolean).join(", ")}
            </div>
          </>
        )}
        {status === "done" && !info && "Unknown airport code."}
      </span>
    </span>
  );
}

export default AirportCode;
